export default __webpack_public_path__ + "static/media/rds.a289e5fb.svg";